import api from '@common/api';
import session from '@common/session';
import { AgreementCode } from '@services/appsync/types';
import create from 'zustand';

interface InboxModelActions {
  acceptAgreements: (agreements: AgreementCode[]) => Promise<{ error?: string; success: boolean }>;
  resendEmail: () => Promise<{ success: boolean; error?: string }>;
}
export const useInboxViewModel = create<InboxModelActions>(() => ({
  acceptAgreements: async (agreements) => {
    const investorID = session.get()?.investorId;
    if (!investorID) return { error: 'No investor ID', success: false };
    try {
      await api.acceptTermsAndConditions({ agreements, investor_account_id: investorID });
      return { success: true };
    } catch {
      return { error: 'Unable to accept terms', success: false };
    }
  },
  resendEmail: async () => {
    const investorID = session.get()?.investorId;
    if (!investorID) return { error: 'No Investor ID from session', success: false };
    try {
      await api.resendEmailVerification({ investor_account_id: investorID });
      return { success: true };
    } catch {
      return { error: 'Unable to send Email Verification', success: false };
    }
  },
}));
